import React from 'react';
import { Check, X, HelpCircle } from 'lucide-react';
import { Badge } from '../Badge';

type StatusKey = 'pass' | 'fail' | 'unable_to_verify';

interface Props {
  status: StatusKey | string;
  /** Override the default label ("Pass" / "Fail" / "Verify"). */
  label?: string;
}

export function StatusBadge({ status, label }: Props) {
  if (status === 'pass') {
    return (
      <Badge variant="success">
        <Check size={12} aria-hidden /> {label ?? 'Pass'}
      </Badge>
    );
  }
  if (status === 'fail') {
    return (
      <Badge variant="error">
        <X size={12} aria-hidden /> {label ?? 'Fail'}
      </Badge>
    );
  }
  return (
    <Badge variant="neutral">
      <HelpCircle size={12} aria-hidden /> {label ?? 'Verify'}
    </Badge>
  );
}
